import { getEnvs } from './env'

const { wsUrl } = getEnvs()

export const createSocket = (channel: string): WebSocket =>
  new WebSocket(`${wsUrl}${channel}`)
